const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');
const { X_CDN, RESOURCE_SIZE, DURATION_SUM } = require('./metrics');

const metrics = [X_CDN, RESOURCE_SIZE, DURATION_SUM];

module.exports = objectOperator({ commons, metrics });
